<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: "App",
  components: {},
};
</script>

<style lang="less">
/* 全局覆盖 Element UI 按钮主色 */
.el-button--primary {
  background-color: #0052d9 !important;
  border-color: #0052d9 !important;
}

.el-button--primary:hover,
.el-button--primary:focus {
  background-color: #1865e0 !important;
  border-color: #1865e0 !important;
}
.el-tag--dark {
  background-color: #1865e0 !important;
  border-color: #1865e0 !important;
}
// .el-pagination.is-background .el-pager li:not(.disabled).active {
//   background-color: #ffaa00;
// }
// .el-pager li:hover {
//   color: #ffaa00;
// }
// .el-pagination.is-background .el-pager li:not(.disabled):hover {
//   color: #ffaa00;
// }
.mb15 {
  margin-bottom: 15px;
}
.kong {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 25px 0;
}

.kong img {
  width: 90px;
  margin-bottom: 17px;
}

.kong .text {
  font-size: 14px;
  color: #999999;
}
</style>
